<template>
      <el-dialog :close-on-click-modal="false" v-dialogDrag title="门店扣款详情" :visible.sync="detailDialog" append-to-body width="60%">
        <el-table :data="list" max-height="200" :header-cell-style="{ background: 'linear-gradient(#6cb3ff, #1873d4)', color: '#eeeeee' }">
          <el-table-column label="门店名称" align="center" prop="storeName" min-width="80"></el-table-column>
          <el-table-column label="账户名称" align="center" prop="rechargeTypeName" min-width="80"></el-table-column>
          <el-table-column label="会员名称" align="center" prop="memberName" min-width="80"></el-table-column>
          <el-table-column label="充值卡编码" align="center" prop="rechargeNum" min-width="100"></el-table-column>
          <el-table-column label="充值卡名称" align="center" prop="rechargeTypeName" min-width="80"></el-table-column>
          <el-table-column label="充值赠送金额" align="center" prop="giftConsumeMoney" min-width="80"></el-table-column>
          <el-table-column label="退款金额" align="center" min-width="100">
            <template slot-scope="scope">
                <el-input v-model="scope.row.refundGiftMoney" placeholder="请输入退款金额" type="number" @change="(val)=>handleUpdataMoney(val,scope.row)"></el-input>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" plain @click="handleConfirm(detailDialog=false)">取 消</el-button>
          <el-button size="mini" type="primary" @click="handleConfirm(detailDialog=false)">确定</el-button>
        </span>
      </el-dialog>
  </template>
  <script>
  export default {
    data() {
      return {
        detailDialog: false,
        list:[],
        refundGiftMoney:0 //退款金额
      };
    },
    methods:{
        handleConfirm(){
            this.$emit('confirm',this.list)
        },
        show(form){
            this.list = form.rechargeAccountGiveList
            this.refundGiftMoney = this.list[0].giftConsumeMoney
            this.list = this.list.map(item=>{
                return {
                    ...item,
                    refundGiftMoney:item.refundGiftMoney?item.refundGiftMoney:0
                }
            })
            this.detailDialog = true
        },
        handleUpdataMoney(val,row){
            let num = (eval(this.list.map(item=>item.refundGiftMoney?item.refundGiftMoney*1:0).join("+"))).toFixed(2)*1
            if( num > this.refundGiftMoney ){
                return this.$alert(`总退款赠送金额最多不能超过${this.refundGiftMoney.toFixed(2)*1}元` , "提示", {
                  confirmButtonText: "确定",
                  confirmButtonClass: "confirmbtnFalses",
                  type: "warning",
                  center: true,
                  callback: (action) => {
                    row.refundGiftMoney = 0
                  },
                });
            }
        }
    }
  };
  </script>
  
  <style>
  </style>
  


// WEBPACK FOOTER //
// src/pages/eashier/refundRecharge/components/storeChargeDetails.vue